let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ez8Ma")).then(() => parcelRequire('faa1O'));